/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { TbMessageCircle } from "react-icons/tb";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import "../../../css/Pages/Pages.css";
import { userDataActionCreators } from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import Loader from "../../Loader";
import NotFoundComponent from "../../NotFoundComponent";
import RenderHome from "../home/RenderHome";
import Modal from "../../Modal/Modal";
import { useHistory } from "react-router-dom";

function MyAppliedLoans() {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    GetAppliedLoans,
    GetAppliedLoanDetailed,
    GetCartProducts,
    ResetUserDataResponse,
  } = bindActionCreators(userDataActionCreators, dispatch);

  const device = () => window.innerWidth < 1080;

  const myAppliedLoans = useSelector((state) => state.user?.myAppliedLoans);
  const isLoading = useSelector((state) => state.user?.isLoading);
  const response = useSelector((state) => state?.user?.response);
  const loanDetailed = useSelector((state) => state?.user?.loan);
  const user = useSelector((state) => state?.auth?.user);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [expandedLoanId, setExpandedLoanId] = useState(null);
  const [messageEditDetailed, setMessageEditDetailed] = useState("");
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    GetAppliedLoans();
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    GetCartProducts();
    // Re-fetch after 3s in case backend needs time to process a fresh submission
    const retry = setTimeout(() => GetAppliedLoans(), 3000);
    return () => clearTimeout(retry);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => setIsMobile(device));
    return () => {};
  }, []);

  useEffect(() => {
    if (response?.state === "ERROR") {
      toast.error(response?.message || "Failed to load loans");
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "SUCCESS") {
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state]);

  const handleTogglePreview = (loanId) => {
    if (expandedLoanId === loanId) {
      setExpandedLoanId(null);
    } else {
      GetAppliedLoanDetailed(loanId);
      setExpandedLoanId(loanId);
    }
  };

  const statusDot = (active, isRejected) => ({
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    background: active ? (isRejected ? "#ef4444" : "#16a34a") : "#d1d5db",
    flexShrink: 0,
  });

  const statusLine = (active) => ({
    flex: 1,
    height: "3px",
    background: active ? "#16a34a" : "#e5e7eb",
    margin: "0 0.25rem",
  });

  const ReadField = ({ label, value }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input
        type="text"
        readOnly
        value={value || "N/A"}
        className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm sm:text-sm"
      />
    </div>
  );

  const renderStatusTracker = (loan) => {
    const stages = [
      { key: "submitted", label: "Submitted" },
      { key: "booked", label: "Booked" },
      { key: "authorized", label: "Authorized" },
      { key: "initiated", label: "Initiated" },
      { key: "paid", label: "Paid" },
    ];
    const isRejected = loan?.rejected?.[0]?.status;

    // A stage counts as reached if its own status is set OR any later stage is
    // reached — you can't be Authorized/Initiated without having been Booked.
    // This keeps the tracker from "jumping" a stage whose record was cleared
    // (e.g. when the Authorizer rejects an already-booked loan for edit).
    const mainStageKeys = ["submitted", "booked", "authorized", "initiated", "paid"];
    const stageReached = (key) => {
      const idx = mainStageKeys.indexOf(key);
      if (idx === -1) return false;
      for (let j = idx; j < mainStageKeys.length; j++) {
        if (loan?.[mainStageKeys[j]]?.[0]?.status) return true;
      }
      return false;
    };

    if (isMobile) {
      const allStages = [...stages];
      if (loan?.status !== "paid") {
        allStages.push({ key: "rejected", label: "Rejected" });
      }

      return (
        <div style={{ display: "flex", flexDirection: "column", padding: "0.1rem 0" }}>
          {allStages.map((stage, i) => {
            const isLastStage = i === allStages.length - 1;
            const isRejectedStage = stage.key === "rejected";
            const stageData = isRejectedStage ? loan?.rejected?.[0] : loan?.[stage.key]?.[0];
            const active = isRejectedStage ? stageData?.status : stageReached(stage.key);
            const dotColor = isRejectedStage ? (active ? "#ef4444" : "#d1d5db") : (active ? "#16a34a" : "#d1d5db");
            const lineColor = active ? (isRejectedStage ? "#ef4444" : "#16a34a") : "#e5e7eb";

            return (
              <div key={stage.key} style={{ display: "flex", gap: "0.65rem", alignItems: "flex-start" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "14px", flexShrink: 0 }}>
                  <div style={{ width: "14px", height: "14px", borderRadius: "50%", background: dotColor, flexShrink: 0 }} />
                  {!isLastStage && (
                    <div style={{ width: "2px", flex: 1, minHeight: "40px", background: lineColor }} />
                  )}
                </div>
                <div
                  style={{ paddingBottom: isLastStage ? 0 : "0.9rem", cursor: isRejectedStage && active ? "pointer" : "default" }}
                  onClick={() => {
                    if (isRejectedStage && active) { setMessageEditDetailed(loan); setOpenMessageModal(true); }
                  }}
                >
                  <div style={{ fontSize: "0.88rem", fontWeight: 600, color: isRejectedStage ? (active ? "#ef4444" : "#9ca3af") : (active ? "#16a34a" : "#9ca3af") }}>
                    {stage.label}
                  </div>
                  <div style={{ fontSize: "0.75rem", color: "#9ca3af" }}>
                    {stageData?.status ? moment(stageData.date).format("MMM Do, YY") : "—"}
                  </div>
                  {isRejectedStage && active && (
                    <div style={{ fontSize: "0.75rem", color: "#ef4444", display: "flex", alignItems: "center", gap: "0.2rem", marginTop: "0.1rem" }}>
                      <TbMessageCircle /> Read
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "0.4rem" }}>
          {stages.map((stage, i) => {
            const active = stageReached(stage.key);
            return (
              <React.Fragment key={stage.key}>
                <div style={statusDot(active, false)} title={stage.label} />
                {i < stages.length - 1 && <div style={statusLine(active)} />}
              </React.Fragment>
            );
          })}
          {loan?.status !== "paid" && (
            <>
              <div style={statusLine(false)} />
              <div style={statusDot(isRejected, true)} title="Rejected" />
            </>
          )}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {stages.map((stage) => {
            const stageData = loan?.[stage.key]?.[0];
            return (
              <div key={stage.key} style={{ textAlign: "center", flex: 1 }}>
                <div style={{ fontSize: "0.7rem", fontWeight: 600, color: stageReached(stage.key) ? "#16a34a" : "#9ca3af" }}>{stage.label}</div>
                <div style={{ fontSize: "0.58rem", color: "#9ca3af" }}>{stageData?.status ? moment(stageData.date).format("MMM Do YY") : "—"}</div>
              </div>
            );
          })}
          {loan?.status !== "paid" && (
            <div
              style={{ textAlign: "center", flex: 1, cursor: isRejected ? "pointer" : "default" }}
              onClick={() => { if (isRejected) { setMessageEditDetailed(loan); setOpenMessageModal(true); } }}
            >
              <div style={{ fontSize: "0.7rem", fontWeight: 600, color: isRejected ? "#ef4444" : "#9ca3af" }}>Rejected</div>
              <div style={{ fontSize: "0.58rem", color: isRejected ? "#ef4444" : "#9ca3af" }}>{isRejected ? moment(loan.rejected[0].date).format("MMM Do YY") : "—"}</div>
              {isRejected && (
                <div style={{ fontSize: "0.65rem", color: "#ef4444", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem" }}>
                  <TbMessageCircle /> Read
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderLoanDetail = (loan) => {
    const isThisExpanded = expandedLoanId === loan?._id;
    const data = isThisExpanded ? loanDetailed : null;
    if (!isThisExpanded) return null;

    // Prefer the cohort stored on the application itself — this shows one
    // specific record, and an old application should read back the way it was
    // taken. Applications predating member_type fall back to the viewer, who
    // only ever sees their own loans here.
    const isStaff = (data?.member_type ?? user?.user_type) === "STAFF";

    return (
      <div className="mt-3">
        {isLoading && !data ? (
          <div className="text-center py-6"><Loader /></div>
        ) : data ? (
          <>
            {/* Personal Information */}
            <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
              <h3 className="text-xl font-semibold mb-4">Personal Information</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Full Name" value={user?.name} />
                <ReadField label="Date of Birth" value={data?.dateOfBirth} />
                <ReadField label="Age" value={data?.age} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="SSNIT" value={data?.ssnit} />
                <ReadField label="ID Type" value={data?.IdCardType} />
                <ReadField label="ID Number" value={data?.IDCardNumber} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <ReadField label="Residential Address" value={[data?.residential_address1, data?.residential_address2].filter(Boolean).join(", ")} />
                <ReadField label="Work Address" value={[data?.work_address1, data?.work_address2].filter(Boolean).join(", ")} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <ReadField label="Phone" value={data?.personal_phone} />
                <ReadField label="Work Phone" value={data?.work_phone} />
                <ReadField label="Email" value={data?.email} />
              </div>
            </div>

            {/* Guarantor 1 */}
            <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
              <h3 className="text-xl font-semibold mb-4">Guarantor 1</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Name" value={data?.guarantor_name} />
                <ReadField label="Staff ID" value={data?.guarantor_staff_id} />
                <ReadField label="Phone" value={data?.guarantor_phone} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Ghana Card" value={data?.guarantor_ghana_card} />
                <ReadField label="GPS Address" value={data?.guarantor_gps} />
                <ReadField label="Occupation" value={data?.guarantor_occupation} />
              </div>
              <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4`}>
                {!isStaff && (
                  <>
                    <ReadField label="Mandate Number" value={data?.guarantor_mandate_number} />
                    <ReadField label="OTP Number" value={data?.guarantor_otp_number} />
                  </>
                )}
                <ReadField label="Relationship" value={data?.guarantor_relationship} />
              </div>
            </div>

            {/* Guarantor 2 */}
            <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
              <h3 className="text-xl font-semibold mb-4">Guarantor 2</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Name" value={data?.guarantor_name2} />
                <ReadField label="Staff ID" value={data?.guarantor_staff_id2} />
                <ReadField label="Phone" value={data?.guarantor_phone2} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Ghana Card" value={data?.guarantor_ghana_card2} />
                <ReadField label="GPS Address" value={data?.guarantor_gps2} />
                <ReadField label="Occupation" value={data?.guarantor_occupation2} />
              </div>
              <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4`}>
                {!isStaff && (
                  <>
                    <ReadField label="Mandate Number" value={data?.guarantor_mandate_number2} />
                    <ReadField label="OTP Number" value={data?.guarantor_otp_number2} />
                  </>
                )}
                <ReadField label="Relationship" value={data?.guarantor_relationship2} />
              </div>
            </div>

            {/* Employment Details */}
            <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
              <h3 className="text-xl font-semibold mb-4">Employment Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Employer" value={data?.employer_name} />
                <ReadField label="Facility" value={data?.facility} />
                <ReadField label="Staff ID" value={data?.staff_id} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <ReadField label="Sector" value={data?.sector} />
                <ReadField label="Employment Start Date" value={data?.employment_start_date} />
              </div>
            </div>

            {/* Loan Details */}
            <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
              <h3 className="text-xl font-semibold mb-4">Loan Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                <ReadField label="Loan Amount" value={data?.loanAmount ? `GH₵ ${data.loanAmount}` : "N/A"} />
                {!isStaff && (
                  <ReadField label="Affordability" value={data?.affordability ? `GH₵ ${data.affordability}` : "N/A"} />
                )}
                <ReadField label="Monthly Deduction" value={data?.monthlyDeduction ? `GH₵ ${data.monthlyDeduction}` : "N/A"} />
              </div>
              <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4 mb-4`}>
                <ReadField label="Loan Term" value={data?.loanTerm ? `${data.loanTerm} months` : "N/A"} />
                {!isStaff && (
                  <>
                    <ReadField label="Mandate Number" value={data?.mandateNumber} />
                    <ReadField label="OTP Number" value={data?.otpNumber} />
                  </>
                )}
              </div>
              <ReadField label="Purpose of Loan" value={data?.purposeForLoan} />
            </div>

            {/* Bank Details */}
            <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
              <h3 className="text-xl font-semibold mb-4">Bank Details</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <ReadField label="Account Holder" value={data?.bank_account_holder_name} />
                <ReadField label="Bank Name" value={data?.bank_name} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <ReadField label="Account Number" value={data?.bank_account_number} />
                <ReadField label="Branch" value={data?.bank_branch} />
              </div>
            </div>

            {/* Uploaded Documents */}
            {(data?.frontIDImage || data?.passportImage) && (
              <div className="form_area bg-white p-6 rounded-lg shadow-md max-w-3xl mx-auto mb-3">
                <h3 className="text-xl font-semibold mb-4">Uploaded Documents</h3>
                <div className={`grid gap-4 ${isMobile ? "grid-cols-1" : "grid-cols-2"}`}>
                  {data?.frontIDImage && (
                    <div className="bg-white p-4 border rounded-lg shadow-sm">
                      <div className="font-semibold text-sm mb-2 text-gray-700">Ghana Card (Front)</div>
                      <img src={data.frontIDImage} alt="Front ID" className="w-full h-40 object-contain rounded-md" />
                    </div>
                  )}
                  {data?.passportImage && (
                    <div className="bg-white p-4 border rounded-lg shadow-sm">
                      <div className="font-semibold text-sm mb-2 text-gray-700">Ghana Card (Back)</div>
                      <img src={data.passportImage} alt="Back" className="w-full h-40 object-contain rounded-md" />
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Collapse */}
            <div className="flex justify-center mt-2 mb-6 max-w-3xl mx-auto">
              <button
                type="button"
                onClick={() => setExpandedLoanId(null)}
                className="button_cancel backBtn px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 focus:outline-none flex items-center gap-2"
              >
                <FaChevronUp /> Collapse
              </button>
            </div>
          </>
        ) : (
          <div className="text-center py-6 text-gray-400">No loan data available</div>
        )}
      </div>
    );
  };

  return (
    <div className="MyOrdersNdPurchases">
      <RenderHome title="My Applied Loans">
        {isLoading && <Loader />}
        <div style={{ maxWidth: "900px", margin: "0 auto", padding: "1rem" }}>

          {myAppliedLoans?.length > 0 ? (
            myAppliedLoans.map((loan, index) => {
              const isExpanded = expandedLoanId === loan?._id;
              const isRejectedWithEdit = loan?.rejected?.[0]?.status && (
                loan?.rejected?.[0]?.editFormChecked ||
                loan?.rejected?.[0]?.editFormAndProductChecked ||
                loan?.rejected?.[0]?.editFormWithoutProductChecked
              );

              return (
                <div key={index} className="bg-white rounded-lg shadow-md mb-4 overflow-hidden">
                  <div className="p-6">
                    {/* Header row */}
                    <div className="flex justify-between items-start flex-wrap gap-3 mb-4">
                      <div>
                        <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                          Loan Application #{index + 1}
                        </div>
                        <div className="text-2xl font-bold text-gray-800">
                          &#8373; {loan?.loanAmount}
                        </div>
                        <div className="text-sm text-gray-500 mt-1">
                          {loan?.loanTerm} months &nbsp;&middot;&nbsp; &#8373; {loan?.monthlyDeduction}/month
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          if (isRejectedWithEdit) {
                            history.push({ pathname: "/edit-loan-form", state: { loan_id: loan?._id } });
                          } else {
                            handleTogglePreview(loan?._id);
                          }
                        }}
                        className={`px-4 py-2 rounded-lg text-white text-sm font-medium flex items-center gap-2 focus:outline-none ${
                          isRejectedWithEdit
                            ? "bg-red-600 hover:bg-red-700"
                            : isExpanded
                            ? "bg-green-400 hover:bg-green-500"
                            : "bg-green-700 hover:bg-green-800"
                        }`}
                      >
                        {!isRejectedWithEdit && (isExpanded ? <FaChevronUp /> : <FaChevronDown />)}
                        {isRejectedWithEdit
                          ? "Edit Rejected Application"
                          : isExpanded
                          ? "Hide"
                          : "View Details"}
                      </button>
                    </div>

                    {/* Status tracker */}
                    {renderStatusTracker(loan)}
                  </div>

                  {/* Expandable detail sections */}
                  {renderLoanDetail(loan)}
                </div>
              );
            })
          ) : (
            <NotFoundComponent title="No Applied Loan Available" />
          )}
        </div>

        {/* Rejection Message Modal */}
        {openMessageModal && (
          <Modal
            title="Rejected Message"
            width={isMobile ? "85%" : "35%"}
            closeModal={setOpenMessageModal}
          >
            <div className="modalBody">
              <div className="message">
                <p>{messageEditDetailed?.rejected[0]?.message}</p>
                {(messageEditDetailed?.rejected[0]?.editFormChecked ||
                  messageEditDetailed?.rejected[0]?.editFormAndProductChecked ||
                  messageEditDetailed?.rejected[0]?.editFormWithoutProductChecked) && (
                  <button
                    onClick={() =>
                      history.push({
                        pathname: "/edit-loan-form",
                        state: { loan_id: messageEditDetailed?._id },
                      })
                    }
                    type="button"
                    className="px-5 py-2.5 mt-4 bg-red-600 text-white font-medium rounded-lg text-sm hover:bg-red-700 focus:outline-none"
                  >
                    Click here to edit form
                  </button>
                )}
              </div>
            </div>
            <div className="modalButton">
              <div className="btnCover">
                <button type="button" onClick={() => setOpenMessageModal(false)} className="cancelBtn">
                  Close
                </button>
              </div>
            </div>
          </Modal>
        )}
      </RenderHome>
    </div>
  );
}

export default MyAppliedLoans;
